import React from 'react';
import { FadeInSection } from './FadeInSection';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
const neighborhoodsData = [{
  name: 'Minneapolis',
  image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600'
}, {
  name: 'Edina',
  image: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=600'
}, {
  name: 'Minnetonka',
  image: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=600'
}, {
  name: 'Saint Paul',
  image: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=600'
}];
export const Neighborhoods = () => {
  const {
    lang
  } = useLanguage();
  const t = translations[lang].neighborhoods;
  return <FadeInSection id="neighborhoods" className="w-full bg-[#f8f4ef] py-24 lg:py-32" data-id="element-204">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12" data-id="element-205">
        <div className="flex flex-col items-center text-center mb-16" data-id="element-206">
          <span className="eyebrow mb-4" data-id="element-207">{t.eyebrow}</span>
          <h2 className="font-serif-display text-3xl md:text-4xl uppercase tracking-wider text-[#1a1a1a]" data-id="element-208">
            {t.headline}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-209">
          {neighborhoodsData.map((hood, index) => <div key={index} className="group relative h-[460px] w-full overflow-hidden cursor-pointer" data-id="element-210">
              <img src={hood.image} alt={hood.name} className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-1000 group-hover:scale-110" data-id="element-211" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent transition-opacity duration-500 group-hover:from-black/90" data-id="element-212" />

              <div className="absolute bottom-8 left-8 right-8" data-id="element-213">
                <h3 className="font-serif-display text-2xl text-white uppercase tracking-wider" data-id="element-214">
                  {hood.name}
                </h3>
                <div className="w-0 h-px bg-[#c9a96e] mt-4 transition-all duration-500 group-hover:w-12" data-id="element-215" />
              </div>
            </div>)}
        </div>
      </div>
    </FadeInSection>;
};